<template>
    <div v-loading="vselect.docCategoryId.loading">
        <div class="background">
            <el-input class="background_input" size="large" v-model="search_form.docTitle" placeholder="输入文档的名称、文档描述等" @keydown.enter="queryList">
                <template #suffix>
                    <el-icon color="#337eff" class="el-input__icon point" @click="queryList">
                        <Search />
                    </el-icon>
                </template>
            </el-input>
            <img class="background_img" src="https://bucket-mvs.oss-cn-beijing.aliyuncs.com/1745573443aaaa.png" alt="">
        </div>
        <div class="info">
            <el-tabs class="info_tabs" v-model="search_form.oneCategoryId" @tab-change="changeOne">
                <el-tab-pane label="全部" name=""></el-tab-pane>
                <el-tab-pane v-for="(item, index) in vselect.docCategoryId.options" :key="'tabs' + index" :label="item.categoryTitle"
                    :name="item.id"></el-tab-pane>
            </el-tabs>
            <div class="info_tabs2">
                <p @click="search_form.twoCategoryId='',queryList()" :class="search_form.twoCategoryId==''?'info_tabs2_items':'info_tabs2_item'">全部</p>
                <p @click="search_form.twoCategoryId=item.id,queryList()" :class="search_form.twoCategoryId==item.id?'info_tabs2_items':'info_tabs2_item'" v-for="(item, index) in twoCategory" :key="'tabs2' + index"
                    :name="item.id">{{ item.categoryTitle }}</p>
            </div>
            <div class="m-resultl">
                <ul class="ul-listl3" v-if="act == 1">
                    <li v-for="(item, index) in list" :key="index">
                        <router-link :to="`/knowledgeInfo/${item.id}`" class="con">
                            <div class="tit">
                                <div v-html="item.docTitle"></div>{{ item.docNumber ? `(${item.docNumber})` : '' }}
                            </div>
                            <div class="desc" v-html="item.docContent"></div>
                            <div class="stips">所属分类：{{ item.categoryName }}</div>
                        </router-link>
                    </li>
                </ul>
                <div class="m-pages">
                    <div class="pages">
                        <el-pagination v-model:currentPage="search.pageNumber" @update:page-size="getDocList()"
                            @update:current-page="getDocList" :page-sizes="[10, 20, 30, 50]"
                            layout=" prev, pager, next, sizes, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
//图标
import { mapGetters } from 'vuex';
import { Search } from '@element-plus/icons-vue'
import { debounce, throttle } from 'throttle-debounce'
export default {
    setup() {
        return {
            state: history.state
        }
    },
    components: {
		Search
	},
    computed: {
        ...mapGetters({
            searchList: 'searchStore/get_search',
        }),
    },
    data() {
        return {
            typeL: [],
            act: 1,
            loading: false,
            search_form: {
                categoryId: '',
                docType: '',
                docTitle: '',
                oneCategoryId:'',
                twoCategory:'',
            },
            twoCategory:[],
            search: {
                categoryId: '',
                docType: '',
                docTitle: '',
                pageNumber: 1,
                pageSize: 10
            },
            list: [],
            total: 0,
            vselect: {
                docCategoryId: {
                    props: {
                        checkStrictly: false,
                        emitPath: false,
                        multiple: true,
                        value: 'id',
                        label: 'categoryTitle',
                        children: 'list'
                    },
                    loading: false,
                    options: []
                }
            },
        };
    },
    mounted() {
        this.vselect_docCategoryId()
    },
    methods: {
        
        changeOne(){
            console.log(this.search_form,'this.vselect.docCategoryId.options',this.vselect.docCategoryId.options)
            this.search_form.twoCategoryId = ''
            if(this.search_form.oneCategoryId==''){
                this.twoCategory = []
            }
            this.vselect.docCategoryId.options.map(e=>{
                if(e.id==this.search_form.oneCategoryId){
                    this.twoCategory = e.list
                }
            })
            this.queryList()
        },
        async vselect_docCategoryId() {
            try {
                this.vselect.docCategoryId.loading = true
                const { records, total } = await this.$api.know.docCateList({
                    pageNumber: 1,
                    pageSize: 1000
                })
                console.log(records, '**********----------**********', this.search_form)
                this.vselect.docCategoryId.options = records
                this.vselect.docCategoryId.loading = false
            } catch (e) {
                this.vselect.docCategoryId.loading = false
                this.vselect.docCategoryId.options = []
            }
        },
        queryList: throttle(300, function () {
            this.search.categoryId = this.search_form.categoryId ? this.search_form.categoryId.join(',') : ''
            this.search.docType = this.search_form.docType;
            this.search.docTitle = this.search_form.docTitle;
            this.search.oneCategoryId = this.search_form.oneCategoryId;
            this.search.twoCategoryId = this.search_form.twoCategoryId;
            this.$store.commit('searchStore/putSearch', this.search_form.docTitle)
            this.getDocList(1)
        }),
        async getDocList(pageNumber) {
            try {
                pageNumber && (this.search.pageNumber = pageNumber)
                this.loading = true
                let param = JSON.parse(JSON.stringify(this.search))
                let docTitle = param.docTitle||''
                delete param.docTitle
                const { records, total } = await this.$api.know.getDocLists(param,{docTitle})
                console.log('recordsrecordsrecords', records)
                this.list = records
                this.total = total
            } catch (e) {
                return console.log(e)
            } finally {
                this.loading = false
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const state = history.state
            console.log('statestatestatestate', state)
            vm.search.categoryId = state.categoryId ? state.categoryId.split(',') : ''
            vm.search.docType = state.docType
            vm.search.docTitle = state.docTitle
            vm.search_form.categoryId = state.categoryId ? state.categoryId.split(',') : ''
            vm.search_form.docType = state.docType
            vm.search_form.docTitle = state.docTitle
            vm.search_form.oneCategoryId = state.twoCategoryId||''
            vm.search_form.twoCategoryId = state.twoCategoryId||''
            vm.queryList()
        })
    }
};
</script>

<style lang="scss" scoped>
body {
    background-color: #fff
}
.info{
    width:100%;
    display:flex;
    flex-wrap: wrap;
    justify-content: center;
    .info_tabs{
        width:1400px;
        margin-top:26px;
    }
    .info_tabs2{
        width:1400px;
        height:40px;
        overflow-x: auto;
        white-space: nowrap;
        .info_tabs2_item{
            display: inline-block;
            padding: 10px 20px;
            background-color: #F4F5F7;
            margin: 0 20px 0 0;
            color:#333333;
            border-radius: 20px;
            cursor: pointer;
        }
        .info_tabs2_items{
            display: inline-block;
            padding: 10px 20px;
            background-color: #EAF0FF;
            margin: 0 20px 0 0;
            color:#487DF7;
            border-radius: 20px;
            cursor: pointer;
        }
    }
}

.background {
    width: 100%;
    position: relative;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .background_input{
        width: 640px;
        z-index: 2;
    }
    .background_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1;
    }
}


.typeL {
    display: flex;
    width: 100%;

    .typeL_line {
        display: inline-block;
        color: #999999;
        font-size: 14px;
        line-height: 60px;
        margin: 0 10px;
    }

    .typeL_title {
        display: inline-block;
        color: #999999;
        font-size: 14px;
        line-height: 60px;
        cursor: pointer;
    }

    .typeL_titles {
        display: inline-block;
        color: #333333;
        font-size: 14px;
        line-height: 60px;
        cursor: pointer;
    }
}


























.navmb {
    .icon {
        margin-right: 10px;
    }
}

.m-searchl {
    overflow: hidden;

    // background: #fff;
    // padding: 20px;
    .search {
        overflow: hidden;
        // margin-bottom: 20px;
        margin-bottom: 20px;
    }

    .history {
        overflow: hidden;

        .ll {
            float: left;
            font-size: 12px;
            color: #999999;
            line-height: 30px;
            margin-right: 14px;
        }

        .rr {
            overflow: hidden;

            span {
                display: block;
                float: left;
                min-width: 82px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 12px;
                color: #666666;
                margin-right: 16px;
                padding: 0 15px;
            }
        }
    }
}

.m-resultl {
    overflow: hidden;
    background-color: #fff;
    padding: 20px 30px;
    width:1400px;
}



.ul-listl3 {
    overflow: hidden;
    margin-bottom: 54px;

    .con {
        display: block;
        overflow: hidden;
        padding: 29px 0 30px;
        border-bottom: 1px dashed #E6E6E6;

        .tit {
            font-size: 18px;
            line-height: 1.333em;
            color: #151822;
            margin-bottom: 14px;
            transition: .5s;

            span {
                color: #337EFF;
            }
        }

        .desc {
            font-size: 14px;
            color: #686868;
            line-height: 2em;
            overflow: hidden;
            margin-bottom: 6px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            /* 确保文本正常换行 */
        }

        .stips {
            font-size: 12px;
            line-height: 2.333em;
            overflow: hidden;
            color: #9c9c9c;
        }
    }

    .con:hover {
        .tit {
            color: #337EFF;
        }
    }
}

.m-pages {
    overflow: hidden;
    text-align: center;
    font-size: 0;

    .pages {
        display: inline-block;
        vertical-align: middle;
    }
}
</style>